(function() {
    'use strict';
    
a3_pilot_reports.controller('TicketCtrl', TicketCtrl);

    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name TicketCtrl
    * @description 
    *  Send a ticket
    * @ngInject
    */
function TicketCtrl($scope,UserFactory, PhotoFactory, TicketAPIService,$location,$uibModal, version) {
    
    var user = UserFactory.getUser();
    user
    $scope.submitted = false;
    $scope.ticket = {};
    $scope.ticket.photos = [];
    $scope.maximumAttatchedPhotos = 3;
    $scope.showMaxImages = false;
    $scope.quality = 0.6;
    $scope.width = 1280;
    $scope.height = 1024;
    $scope.sizeLimitKb = 1000;
    $scope.imageTooLargeMsg = false;
    $scope.gotoHome = gotoHome;
    $scope.state = 'ticket';

    $scope.ticket.Version = version;
        
    appendPhoto();

    $scope.sendTicket = sendTicket;
    $scope.imageUploaded = imageUploaded;
    $scope.removePhoto = removePhoto;
    
    if(user && user.aimsId && UserFactory.isLoggedIn()){
        $scope.ticket.aimsId = user.aimsId
        $scope.isLogged = true;
    }
    
    /**
     * Redirects to home view
     * @memberof TicketCtrl
     */
    function  gotoHome(){
        $location.path("/");
    }
    
    /**
     * Send  application ticket information
     * @memberof TicketCtrl
     */
    function sendTicket(){
        $scope.submitted = true;
        if (validateTicket()){
            var modalInstance = $uibModal.open({
            templateUrl: 'views/Dialogs/dlgTicketSend.html',
            controller: 'TicketModalCtrl',
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            resolve: {
                ticket: function() {
                    return $scope.ticket;
                },
            }
        })

        modalInstance.result.then(function() {
              $location.path("/");   
            });
        }
        
    }
    
    
    /**
     * Validate ticket before sending
     * @memberof TicketCtrl
     * @return {boolean} isValid
     */
    function validateTicket(){
        var isValid = false;
        
        if ($scope.ticket.aimsId && $scope.ticket.title && $scope.ticket.description){
            isValid = true;
        }
        
        return isValid;
    }
    
    /**
     * is Image Too Large 
     * @memberof TicketCtrl
     * @return {boolean} isValid
     */
    function isImageTooLarge(image) {
        var isLarge= false;
        if (image && image.dataURL != null) {
            isLarge = (image.dataURL.length > $scope.sizeLimitKb * 1024);
        }
        return isLarge;
    }

    /**
     * Upload Image
     * @memberof TicketCtrl
     */
    function imageUploaded(data,img) {
        //console.log('told of a new image', imageResult, this.imageBrowsed, $scope.imageBrowsed);
        var imageResult = data; //$scope.imageBrowsed;
        if (imageResult != null) {
            if(isImageTooLarge(data)){
                $scope.imageTooLargeMsg = true;
            }else{
                $scope.imageTooLargeMsg = false;
                img.PhotoData = imageResult.dataURL;
                img.FileType = imageResult.fileType || imageResult.file.type;
                img.Remarks = imageResult.fileName;
                appendPhoto();
            }

        }
    }
    
    /**
     * Allows to add more photos up to the maximum number allowed
     * @memberof TicketCtrl
     */
    function appendPhoto(){
        if($scope.ticket.photos.length< $scope.maximumAttatchedPhotos){
            var photo = PhotoFactory.createNew();
            $scope.ticket.photos.push(photo);
        }else{
            $scope.showMaxImages = true;
        }
    }
    
    /**
     * Remove Selected photo
     * @memberof TicketCtrl
     * @param {object} photo
     */
    function removePhoto(photo){
        PhotoFactory.deleteFromList(photo, $scope.ticket.photos);
        if($scope.showMaxImages){
            appendPhoto();
        }
        $scope.showMaxImages = false;

    }
    
    

}

})();